var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "87b3ebc4aa081aa559f111ce4da09c92906093d0"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["dodo-landing-page@delivery-hero-pm"] = {
  id: "87b3ebc4aa081aa559f111ce4da09c92906093d0"
};